module.exports = __webpack_public_path__ + "img/content-with-img-links-infiniti.5e8ca0fd.jpg";